const emptyStateStr = [
    'אין הגדרת HELP',
    'Er is geen hulp.',
    "Non c'è aiuto.",
    'Aucune aide disponible actuellement.',
    'Keine Hilfe verfügbar.',
    'There is no help.'
];
export const isEmptyState = str => emptyStateStr.includes(str);
